let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bnpcq")).then(() => parcelRequire('l1DVf'));